export const CAPTCHA_TIMEOUT: number = 1000 * 60 * 8; // 8 minutes
